import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["currentUser"]),
    noUser() {
      console.log("calling");
      console.log(this.currentUser === null);
      return this.currentUser === null;
    }
  },
  methods: {
    apply() {
      window.open("https://forms.gle/jqnePa1KMmB5U3Hj7", "_blank");
    }
  }
};
